// 保護者請求 利用料明細 / 請求書/領収書のバリデーション用vuex
const claimParentsState = () => ({
  data: {},
})

export default {
  namespaced: true,
  state: claimParentsState(),
  mutations: {
    valueErrSet(state: any, value: any) {
      state.data = value
    },
  },
}
